export default "__VITE_ASSET__BaiWLIVx__"